


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { User } from '@/models/user/user.model';
import { TDirectory, TFile, UserDetailsViewModel } from '@/types/apiServerContract';
import { Role } from '@/core/security/Role';
import { AdminApi } from '@/services/api/api.admin';
import FilePicker from '@/components/dashboard/FilePicker.vue';
import { RealmsModule } from '@/store/modules/realms/realms.store';

@Component({
    components: { FilePicker }
})
export default class EditUserAllowedCoreFiles extends Vue {
	@Prop({ required: true })
	user!: User;

	@Prop({ required: true })
	userData!: UserDetailsViewModel;

	permissions: string[] = [ApiPermissions.Realm.GetCoreFiles];
	roles: Role[] = [Role.SuperAdmin];

	loading: boolean = false;
    files: TDirectory[] = [];

	selectedFiles: TFile[] = [];

	get ActiveRealmId() {
	    return RealmsModule.activeRealmId;
	}

	removeFile(file: TFile) {
	    this.selectedFiles.splice(this.selectedFiles.indexOf(file), 1);
	}

	reset() {
	    this.selectedFiles = this.userData.user.fileAccess.filter(x => x.realmId === this.ActiveRealmId).map(x => ({
	        fullPath: x.filePath,
	        extension: '',
	        name: x.filePath
	    } as TFile));
	}

	async getCoreFiles() {
	    const result = await AdminApi.GetCoreFiles();
	    this.files = result.directories;
	}

	created() {
	    this.reset();
	    this.getCoreFiles();
	}

	async update() {
	    this.loading = true;

	    try {
	        const result = await AdminApi.UpdateAllowedCoreFilesForRealm({
	            filePaths: this.selectedFiles.map(x => x.fullPath),
	            userId: this.user.id
	        });
	        if (result.data) {
	            this.$bvToast.toast(`${this.userData.user.userName}'s allowed core files have been updated for ${RealmsModule.ActiveRealm!.name}`, {
	                variant: 'success',
	                title: 'Success'
	            });
	        }
	    } finally {
	        this.loading = false;
	    }
	}
}
